export default __webpack_public_path__ + "static/media/minifloatswitch.5a3631c7.jpg";